import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {HStack, useMultiStyleConfig, Stack} from '@chakra-ui/react'

/**
 * Omnibus pricing scenarios:
 * 1. Do not show the omnibus price when it is less than the current price or equal to the list price.
 * 2. Show the omnibus price when it is the same as the current price.
 * 3. Show the omnibus price and the discount otherwise.
 * the constants showOmnibusPrice and showOmnibusPriceDiscount are used to determine which scenario to show.
 */

const OmnibusPrice = ({
    priceData,
    currency,
    omnibusExpandedView,
    showDiscount = false,
    variant,
}) => {
    const intl = useIntl()
    const {omnibusPrice, omnibusPriceDiscount, showOmnibusPrice, showOmnibusPriceDiscount} =
        priceData

    const styles = useMultiStyleConfig('OmnibusPrice', {variant})
    const omnibusPriceDiscountText = `(-${intl.formatNumber(omnibusPriceDiscount, {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })})`

    const omnibusPriceText = `${intl.formatNumber(omnibusPrice, {
        style: 'currency',
        currency,
    })}`

    return (
        showOmnibusPrice &&
        (omnibusExpandedView ? (
            <HStack {...styles.container}>
                <Text>
                    {intl.formatMessage({
                        defaultMessage: 'Lowest Price last 30 days',
                        id: 'last.lower.price.omnibus',
                    })}
                </Text>

                <Text style={showOmnibusPriceDiscount ? {...styles.price} : {}}>
                    {omnibusPriceText}
                </Text>

                {showOmnibusPriceDiscount && showDiscount && (
                    <Text {...styles.discount}>{omnibusPriceDiscountText}</Text>
                )}
            </HStack>
        ) : (
            <Stack {...styles.container}>
                <Text style={showOmnibusPriceDiscount ? {...styles.price} : {}}>
                    {omnibusPriceText}
                </Text>

                <Text>
                    {intl.formatMessage({
                        defaultMessage: 'Lowest Price last 30 days',
                        id: 'last.lower.price.omnibus',
                    })}
                </Text>
            </Stack>
        ))
    )
}

OmnibusPrice.propTypes = {
    currency: PropTypes.string,
    priceData: PropTypes.shape({
        omnibusPrice: PropTypes.number,
        omnibusPriceDiscount: PropTypes.number,
        showOmnibusPrice: PropTypes.bool,
        showOmnibusPriceDiscount: PropTypes.bool,
    }),
    omnibusExpandedView: PropTypes.bool,
    showDiscount: PropTypes.bool,
    variant: PropTypes.string,
}

export default OmnibusPrice
